// extracted by mini-css-extract-plugin
export default {"tooltip":"ClientApplicationLabel_tooltip__747vy"};